import { useWallet } from '@solana/wallet-adapter-react'
import { atom, useAtom } from 'jotai'
import { Dispatch, SetStateAction } from 'react'
import { postSignature, preSignature } from '../data/Signature'
import { captureException } from '@sentry/nextjs'
import log from '../events/log'
import { ConnectWalletEvent } from '../events/account_events'
import bs58 from 'bs58'
import { auth } from '../data/FirebaseInit'

export enum SIGN_IN_STATE {
  NONE,
  CANCELLED,
  SIGNING_IN,
}

const rwSignInStateAtom = atom<SIGN_IN_STATE>(SIGN_IN_STATE.NONE)
const rwMessageAtom = atom<Uint8Array | null>(null)
const rwUUIDAtom = atom<string | null>(null)

export const useSignIn = (): {
  signInState: SIGN_IN_STATE
  signIn: () => Promise<void>
  setSignInState: Dispatch<SetStateAction<SIGN_IN_STATE>>
  openSignInModal: () => Promise<void>
} => {
  const [signInState, setSignInState] = useAtom(rwSignInStateAtom)
  const { publicKey, signMessage } = useWallet()
  const [message, setMessage] = useAtom(rwMessageAtom)
  const [uuid, setUUID] = useAtom(rwUUIDAtom)

  const openSignInModal = async (): Promise<void> => {
    setSignInState(SIGN_IN_STATE.SIGNING_IN)
    await fetchMessage()
  }

  const fetchMessage = async (): Promise<void> => {
    const resp = await preSignature()
    const msg = resp.message
    const message = new TextEncoder().encode(msg)
    setMessage(message)
    setUUID(resp.uuid)
  }

  const signIn = async (): Promise<void> => {
    if (!publicKey || !signMessage || !message || !uuid) {
      console.log(uuid)
      console.log(message)
      setSignInState(SIGN_IN_STATE.CANCELLED)
      return
    }

    try {
      const sig = await signMessage(message)
      const postSigResp = await postSignature(publicKey.toString(), uuid, bs58.encode(sig))
      await auth.signInWithCustomToken(postSigResp.token)

      log(new ConnectWalletEvent())

      setSignInState(SIGN_IN_STATE.NONE)
      setMessage(null)
      setUUID(null)
    } catch (err) {
      setSignInState(SIGN_IN_STATE.CANCELLED)
      captureException(err)
    }
  }

  return {
    signInState,
    signIn,
    setSignInState,
    openSignInModal,
  }
}
